import src from "IMAGE";
export default { src, width: 1782, height: 850, blurWidth: 0, blurHeight: 0};
